import { render, staticRenderFns } from "./ActivityOpenQuestionItemDetail.vue?vue&type=template&id=6389ee68&scoped=true&"
import script from "./ActivityOpenQuestionItemDetail.vue?vue&type=script&lang=js&"
export * from "./ActivityOpenQuestionItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./ActivityOpenQuestionItemDetail.vue?vue&type=style&index=0&id=6389ee68&lang=scss&scoped=true&"
import style1 from "./ActivityOpenQuestionItemDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6389ee68",
  null
  
)

export default component.exports